import type { PaginationProps } from 'antd';

export const getShowTotal = (pagination: PaginationProps) =>
  pagination.showTotal ||
  (() => {
    const { total } = pagination;

    if (!total || total <= 0) return '';

    return `${total} ${total === 1 ? 'item' : 'items'} in total`;
  });
